import React, { useState,useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  useTheme,
  Divider,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LockIcon from "@mui/icons-material/Lock";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { entity_id, getGeolocation, location, Platform } from "../../Utils/Const";
import useIPAddress from "../../Utils/useIPAddress";
import { baseapi } from "../../Environmentalurl";
import ArrowBackIosNewOutlined from "@mui/icons-material/ArrowBackIosNewOutlined";
import DashboardHeader from "../../Dashboard/DashboardHeader";
import api from "../../Utils/Api";

const Changetpin = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const [oldTpin, setOldTpin] = useState("");
  const [newTpin, setNewTpin] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    message: "",
    type: "",
  });

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const ip = useIPAddress();

  const handleToggleVisibility = (field) => {
    if (field === "old") setShowOld((prev) => !prev);
    if (field === "new") setShowNew((prev) => !prev);
    if (field === "confirm") setShowConfirm((prev) => !prev);
  };

  const handleSubmit = async () => {
    const mobileNumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );

    try {
      const requestBody = {
        ReqType: "MT_TPIN_Management",
        Mobilenumber: mobileNumber,
        Statement: "UpdateTPIN",
        TPIN: newTpin,
        OldTPIN: oldTpin,
        IsTPINEnabled: "True",
        Platform: Platform,
        EntityID: entity_id,
        GeoLocation: location,
        MachineID: ip,
      };

      const response = await api.post(`${baseapi}/tpin`, requestBody);

      const { Response_Code, Message } = response.data;

      setDialog({
        open: true,
        title: Response_Code === "1690" ? "Success" : "Failed",
        message: Message || "Something went wrong",
        type: Response_Code === "1690" ? "success" : "error",
      });
    } catch (err) {
      setDialog({
        open: true,
        title: "Error",
        message: "Something went wrong while updating TPIN!",
        type: "error",
      });
    }
  };

  const handlehomenavigation = () => {
    navigate("/profile-settings/tpin");
  };

  return (
    <>
      {/* PAGE WRAPPER */}
      <DashboardHeader />
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: isDark ? "#0a122a" : "#f4f7fb",
          p: { xs: 2, md: 4 },
        }}
      >
        {/* CENTER CARD */}
        <Card
          sx={{
            maxWidth: 500,
            mx: "auto",
            mt: { xs: 4, sm: 6 },
            borderRadius: 3,
            backgroundColor: isDark ? "#1e293b" : "#ffffff",
            boxShadow: isDark
              ? "0px 0px 10px rgba(255,255,255,0.06)"
              : "0px 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            {/* Title Row */}
            <Box display="flex" alignItems="center" mb={3} gap={1.5}>
              <IconButton
                onClick={handlehomenavigation}
                sx={{
                  bgcolor: isDark ? "#1e293b" : "white",
                  color: "#1e5fd8",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
              >
                <ArrowBackIosNewOutlined />
              </IconButton>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ color: isDark ? "#ffffff" : "#111" }}
              >
                Change TPIN
              </Typography>
            </Box>

            {/* OLD TPIN */}
            <TextField
              label="Enter Old TPIN"
              fullWidth
              type={showOld ? "text" : "password"}
              margin="normal"
              value={oldTpin}
              onChange={(e) => setOldTpin(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: isDark ? "#0f172a" : "#f7f7f7",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleToggleVisibility("old")}>
                      {showOld ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* NEW TPIN */}
            <TextField
              label="Enter New TPIN"
              fullWidth
              type={showNew ? "text" : "password"}
              margin="normal"
              value={newTpin}
              onChange={(e) => setNewTpin(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: isDark ? "#0f172a" : "#f7f7f7",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleToggleVisibility("new")}>
                      {showNew ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* CONFIRM TPIN */}
            <TextField
              label="Confirm New TPIN"
              fullWidth
              type={showConfirm ? "text" : "password"}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: isDark ? "#0f172a" : "#f7f7f7",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleToggleVisibility("confirm")}
                    >
                      {showConfirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* SECURITY TIPS */}
            <Box
              sx={{
                backgroundColor: isDark ? "#0f172a" : "#e9f5e9",
                p: 2,
                mt: 2,
                borderRadius: 2,
              }}
            >
              <Typography
                fontWeight="bold"
                color="success.main"
                variant="body2"
                gutterBottom
              >
                Security Tips:
              </Typography>

              <Typography variant="caption" display="block">
                • Use a combination of numbers
              </Typography>
              <Typography variant="caption" display="block">
                • Avoid using sequential numbers
              </Typography>
              <Typography variant="caption" display="block">
                • Don’t share your TPIN with anyone
              </Typography>
              <Typography variant="caption" display="block">
                • Change your TPIN regularly
              </Typography>
            </Box>

            {/* BUTTON */}
            <Button
              variant="contained"
              color="success"
              fullWidth
              sx={{ mt: 3 }}
              onClick={handleSubmit}
            >
              Change TPIN
            </Button>
          </CardContent>
        </Card>
      </Box>

      {/* SUCCESS / ERROR POPUP */}
      <Dialog
        open={dialog.open}
        onClose={() => setDialog({ ...dialog, open: false })}
        maxWidth="xs"
        fullWidth
      >
        <Box textAlign="center" py={3}>
          <Box
            display="inline-flex"
            justifyContent="center"
            alignItems="center"
            width={70}
            height={70}
            borderRadius="50%"
            bgcolor={dialog.type === "success" ? "#22c55e" : "#f44336"}
            color="white"
            mx="auto"
          >
            {dialog.type === "success" ? (
              <CheckCircleIcon sx={{ fontSize: 40 }} />
            ) : (
              <ErrorIcon sx={{ fontSize: 40 }} />
            )}
          </Box>

          <DialogTitle>{dialog.title}</DialogTitle>

          <DialogContent>
            <Typography variant="body2" color="text.secondary">
              {dialog.message}
            </Typography>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => setDialog({ ...dialog, open: false })}
              variant="contained"
              color={dialog.type === "success" ? "success" : "error"}
            >
              OK
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default Changetpin;
